import React from 'react';

export function SeveralItemsColumnFormatter(cellContent, showTitle = false, limitWidth = true) {

  const mappedCellContent = cellContent
    ? (cellContent.map(item => {
    return (
        <div title={showTitle ? item : ''}
             className={`text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap 
             ${limitWidth ? 'limited-content-width-column' : ''}`}>
          {item}
        </div>
    )
  }))
    : []

  return (
    <div>
      {mappedCellContent}
    </div>
  );
}
